/* ============================================================
   Custom "Sort by" dropdown (listing page)
   The native <select> stays in the form and still drives sorting
   (facets.js listens for its `input` event). We just hide it and
   render a styleable list so the selected/hovered option can be
   gold instead of the un-stylable OS highlight. Re-enhances after
   facets.js re-renders the .sorting area; degrades to the native
   select when this script doesn't run.
   ============================================================ */
(function () {
  if (!document.body.classList.contains('wg-faceted')) return;

  function enhance(select) {
    if (select.dataset.sortEnhanced) return;
    select.dataset.sortEnhanced = 'true';

    const nativeWrap = select.closest('.select');
    if (nativeWrap) nativeWrap.style.display = 'none';

    const root = document.createElement('div');
    root.className = 'facet-sort';

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'facet-sort__button';
    button.setAttribute('aria-haspopup', 'listbox');
    button.setAttribute('aria-expanded', 'false');

    const label = document.createElement('span');
    label.className = 'facet-sort__label';
    label.textContent = select.options[select.selectedIndex] ? select.options[select.selectedIndex].text : '';
    button.appendChild(label);

    const caret = document.createElement('span');
    caret.className = 'facet-sort__caret';
    caret.setAttribute('aria-hidden', 'true');
    button.appendChild(caret);

    const list = document.createElement('ul');
    list.className = 'facet-sort__list';
    list.setAttribute('role', 'listbox');
    list.hidden = true;

    Array.from(select.options).forEach((opt, i) => {
      const li = document.createElement('li');
      li.className = 'facet-sort__option';
      li.setAttribute('role', 'option');
      li.dataset.value = opt.value;
      li.textContent = opt.text;
      if (i === select.selectedIndex) li.setAttribute('aria-selected', 'true');
      li.addEventListener('click', () => {
        if (select.value !== opt.value) {
          select.value = opt.value;
          select.dispatchEvent(new Event('input', { bubbles: true }));
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
        label.textContent = opt.text;
        list.querySelectorAll('.facet-sort__option').forEach((o) =>
          o.toggleAttribute('aria-selected', o === li)
        );
        close();
      });
      list.appendChild(li);
    });

    function open() {
      list.hidden = false;
      root.classList.add('is-open');
      button.setAttribute('aria-expanded', 'true');
      document.addEventListener('click', onDocClick);
      document.addEventListener('keydown', onKey);
    }
    function close() {
      list.hidden = true;
      root.classList.remove('is-open');
      button.setAttribute('aria-expanded', 'false');
      document.removeEventListener('click', onDocClick);
      document.removeEventListener('keydown', onKey);
    }
    function onDocClick(e) {
      if (!root.contains(e.target)) close();
    }
    function onKey(e) {
      if (e.key === 'Escape') close();
    }

    button.addEventListener('click', (e) => {
      e.preventDefault();
      list.hidden ? open() : close();
    });

    root.appendChild(button);
    root.appendChild(list);
    if (nativeWrap) {
      nativeWrap.parentElement.insertBefore(root, nativeWrap);
    } else {
      select.parentElement.appendChild(root);
    }
  }

  let pending = false;
  function scan() {
    pending = false;
    document.querySelectorAll('.facets__form .facet-filters__sort').forEach(enhance);
  }
  function scheduleScan() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(scan);
  }

  scan();

  // facets.js replaces the .sorting markup on each filter/sort change —
  // re-enhance the fresh native select when that happens.
  const observed = document.getElementById('FacetFiltersForm') || document.body;
  new MutationObserver(scheduleScan).observe(observed, { childList: true, subtree: true });
})();
